import { LabelModel, LabelModelGenerics, LabelModelOptions } from '@projectstorm/react-diagrams-core';
import { DeserializeEvent } from '@projectstorm/react-canvas-core';

export interface ConditionLabelModelOptions extends LabelModelOptions {
	label?: string;
}

export interface ConditionLabelModelGenerics extends LabelModelGenerics {
	OPTIONS: ConditionLabelModelOptions;
}

export class ConditionLabelModel extends LabelModel<ConditionLabelModelGenerics> {
  constructor(options: ConditionLabelModelOptions = {}) {
    super({
      ...options,
      offsetY: options.offsetY == null ? -0 : options.offsetY,
      offsetX: options.offsetX == null ? -30 : options.offsetX,

      type: 'conditionLabel',
    });
  }

  setLabel(label: string) {
    this.options.label = label;
  }

  deserialize(event: DeserializeEvent<this>) {
    super.deserialize(event);
    this.options.label = event.data.label;
  }

  removeLink() {
    this.parent.remove();
    this.fireEvent({ link: this.parent }, 'linkDeleted');
  }

  serialize() {
    return {
      ...super.serialize(),
      label: this.options.label,
    };
  }
}
